export default __webpack_public_path__ + "magento.c33990e1.png";